module.exports = ".modal-title {\n  display: inline; }\n\n.btn-secondary {\n  color: #000000 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/editprojectpermissionmodal.component.scss
// module id = 589
// module chunks = 1